import { render, staticRenderFns } from "./shareRecordModal.vue?vue&type=template&id=612e6e1e&scoped=true&"
import script from "./shareRecordModal.vue?vue&type=script&lang=js&"
export * from "./shareRecordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612e6e1e",
  null
  
)

export default component.exports